import "core-js/modules/es.array.push.js";
export default {
  props: {
    partyCode: String,
    type: String,
    value: [String, Number]
  },
  data() {
    return {
      emailList: [],
      checkEmailTimer: null,
      showErrorMsg: false
    };
  },
  computed: {
    nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    }
  },
  watch: {
    nativeInputValue() {
      this.setNativeInputValue();
    }
  },
  created() {
    this.getEmailList();
  },
  mounted() {
    this.setNativeInputValue();
  },
  methods: {
    getInput() {
      return this.$refs.input;
    },
    setNativeInputValue() {
      const input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    getEmailList() {
      if (!this.partyCode) return;
      this.axios.get(`/partyline-backend/stt/transcript/queryEmails/${this.partyCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.emailList = result.map(item => {
            if (this.type === 'sendBySlack' && item.address.includes('slack.com')) {
              return item.address;
            }
            if (this.type === 'sendByEmail' && !item.address.includes('slack.com')) {
              return item.address;
            }
          }).filter(address => address !== undefined);
        }
      });
    },
    addEmail(event, type) {
      if (this.nativeInputValue === '') return;
      const email = type === 'input' ? this.nativeInputValue.slice(0, -1) : this.nativeInputValue;
      const canAddEmail = this.validateEmail(email);
      if (canAddEmail) {
        this.emailList.push(email);
        const input = this.getInput();
        input.value = '';
        this.$emit('input', '');
        this.$emit('addEmail', this.emailList);
      } else {
        this.showErrorMsg = true;
      }
    },
    checkEmail(event) {
      const targetValue = event.target.value;
      if (targetValue === this.nativeInputValue) return;
      this.showErrorMsg = false;
      this.$emit('input', targetValue);
      // 如果当前输入包含，号则添加邮箱
      if (targetValue.includes(',') || targetValue.includes('，')) {
        this.addEmail('', 'input');
        return;
      }
      this.$nextTick(this.setNativeInputValue);
      if (this.checkEmailTimer) clearTimeout(this.checkEmailTimer);
      this.checkEmailTimer = setTimeout(() => {
        this.showErrorMsg = false;
        if (this.nativeInputValue && !this.validateEmail(this.nativeInputValue)) {
          this.showErrorMsg = true;
        }
      }, 1000);
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase()) && !this.emailList.includes(email);
    },
    deleteEmail(email) {
      this.emailList = this.emailList.filter(item => item !== email);
      this.$emit('deleteEmail', email);
    }
  }
};